module.exports = __webpack_public_path__ + "static/media/link.55356416.png";